const scrollContest = ($container) => {
  const $trigger = $container.find('@scrollToNextContest');

  if ($trigger.length > 0) {
    init();
  }


  function init() {
    const scrollPage = ($target) => {
      $('body, html').stop().animate(
        { scrollTop: $target.offset().top - 70 },
        500,
        // afterScroll(),
      );
    };

    setTimeout(() => {
      scrollPage();
    }, 500);

    $trigger.each(function() {
      const $this = $(this);
      $this.on('click', () => {
        const $target = $this.closest('.dashboard__item').next('.dashboard__item');
        scrollPage($target);
      });
    });
    $trigger.last().hide();
  }
};

export default scrollContest;

